// extracted by mini-css-extract-plugin
export default {"backButtonRow":"PanelHeader_backButtonRow__b1EEJ","backButton":"PanelHeader_backButton__Ve9qL"};